import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { ServicePlanBillingPolicy } from 'src/features/servicePlanBillingPolicies/utils/types';
import { PatchServicePlanBillingPolicyFormSchemaValues } from 'src/features/servicePlanBillingPolicies/utils/formSchema';

const RESOURCE =
    '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-billing-policy/:billingPolicyId/';

type MutationFnType = typeof mutationFn;

interface DTO extends PatchServicePlanBillingPolicyFormSchemaValues {
    servicePlanItemId: string;
    billingPolicyId: string;
}

const mutationFn = ({ billingPolicyId, servicePlanItemId, ...data }: DTO): Promise<ServicePlanBillingPolicy> => {
    return axios.patch(formatResourcePath(RESOURCE, { servicePlanItemId, billingPolicyId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePatchServicePlanBillingPolicy };
